"use client"

import dynamic from "next/dynamic"

export const EditorClientLazy = dynamic(
  () => import("./index").then((m) => m.EditorClient),
  { ssr: false },
)
